<button [routerLink]="['/game', category]"
  class="button primary categories w-full animate-fade-in md:h-[182px]">{{category}}</button>